import { useUserMediaPreviewStreamConsumer } from "../hooks/useUserMedia";

import { Video } from "./video-element";

export default function UserMediaSettings() {
  const {
    previewCamStream,
    startPreviewStream,
    switchPreviewCamDevice,
    switchPreviewMicDevice,
    previewStreamCalled,
    resetPreviewStreamCallStatus,
    previewCamDeviceId,
    previewMicDeviceId,
    camDevices,
    micDevices,
    savePreviewDeviceSelections,
  } = useUserMediaPreviewStreamConsumer();

  return (
    <div id="temp-settings">
      <div>
        <Video srcObject={previewCamStream} autoPlay muted />
        <hr />
        <button onClick={savePreviewDeviceSelections} className="w-100">
          Save Settings
        </button>
      </div>
      <div>
        {previewStreamCalled === true && (
          <>
            <p>Waiting for permission...</p>
            <p>Click on "allow" in the browser prompt.</p>
          </>
        )}
        {previewStreamCalled !== true && (
          <>
            <div>
              <label>Camera:</label>
              <DeviceList devices={camDevices} selectedDevice={previewCamDeviceId} onChange={switchPreviewCamDevice} />
            </div>
            <hr />
            <div>
              <label>Microphone:</label>
              <DeviceList devices={micDevices} selectedDevice={previewMicDeviceId} onChange={switchPreviewMicDevice} />
            </div>
          </>
        )}
        {previewStreamCalled instanceof Error && (
          <div>
            <p>Error: Can not get user media streams.</p>
            {(previewStreamCalled.name === "AbortError" || previewStreamCalled.name === "NotReadableError") && (
              <p>Something prevented this to work.</p>
            )}
            {(previewStreamCalled.name === "NotAllowedError" || previewStreamCalled.name === "SecurityError") && (
              <p>Security settings preventing this to work.</p>
            )}
            {(previewStreamCalled.name === "NotFoundError" || previewStreamCalled.name === "OverconstrainedError") && (
              <p>No supported devices found.</p>
            )}
            <button onClick={startPreviewStream}>Try Again</button>
            <button onClick={resetPreviewStreamCallStatus}>Dismiss</button>
          </div>
        )}
      </div>
    </div>
  );
}

function DeviceList({ devices, selectedDevice, onChange }) {
  return (
    <select value={selectedDevice} onChange={(e) => onChange(e.target.value)}>
      {devices.map((device) => (
        <option key={device.deviceId} value={device.deviceId}>
          {device.label}
        </option>
      ))}
    </select>
  );
}
